import { post, remove } from '@/api/base'

const industryZoneIdentifiersApi = {
  create: async params => {
    return await post({
      path: `industry/zones/identifier`,
      params,
    })
  },
  delete: async zoneUuid => {
    return await remove({
      path: `industry/zones/identifier/${zoneUuid}`,
    })
  },
}

export default industryZoneIdentifiersApi
